import { logger } from "./logger";
import { resizeImage } from "./imageResize";

export async function validateAndResizeImage(file, component) {
  if (!file.type.startsWith("image/")) {
    logger.warn(component, 'thumbnail_invalid_type', { fileType: file.type });
    return { blob: null, error: "Please choose an image file." };
  }
  try {
    const blob = await resizeImage(file);
    return { blob, error: null };
  } catch (err) {
    logger.error(component, 'thumbnail_resize_failed', { error: err.message });
    return { blob: null, error: "Couldn't process that image. Try a different photo." };
  }
}
